import styled from 'styled-components';

export const ManageCountryListLinkWrapper = styled.div`
  a {
    color: ${({ theme }) => theme.link.color.default};
  }
`;
